module.exports = __webpack_public_path__ + "img/插图.4160e1fa.png";